// angular.module("HeroPRO")

// 	.directive('hpInputType3',

export default function InputTypeRadioDirective() {
    return {
        restrict: 'E',
        templateUrl: 'app/productCenter/pages/productdetail/inputTypes/templates/radio.html',
        /* @ngInject */
        controller($scope, $rootScope) {
            const vm = this;

            vm.numberInput = null;

            vm.dataSource = $scope.objectSource;
            vm.form = $scope.formSource;

            vm.radio = vm.dataSource.InputOptions[0].InputOptionId;


			    // Common
            vm.inputChanged = function () {
				    $scope.inputChanged();
            };

            if ($scope.last) {
				    $rootScope.$broadcast('inputTypesDirective.filtersLoaded');
            }
        },
        controllerAs: 'inputTypes',
    };
}



// WEBPACK FOOTER //
// ./src/app/productCenter/pages/productdetail/inputTypes/directives/inputTypeRadioDirective.js